
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "atlas-simple-authorizer"
    }}>{`Atlas Simple Authorizer`}</h1>
    <h2 {...{
      "id": "setting-up-atlas-to-use-simple-authorizer"
    }}>{`Setting up Atlas to use Simple Authorizer`}</h2>
    <p>{`As detailed in Atlas `}<a parentName="p" {...{
        "href": "#/AuthorizationModel"
      }}>{`Authorization Model`}</a>{`, Apache Atlas supports a pluggable authorization
model. Simple authorizer is the default authorizer implementation included in Apache Atlas. Simple authorizer uses
policies defined in a JSON file. This document provides details of steps to configure Apache Atlas to use the simple
authorizer and details of the JSON file format containing authorization policies.`}</p>
    <h2 {...{
      "id": "configure-apache-atlas"
    }}>{`Configure Apache Atlas`}</h2>
    <p>{`To configure Apache Atlas to use simple authorizer, include the following properties in application.properties config file:`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`atlas.authorizer.impl=simple
atlas.authorizer.simple.authz.policy.file=/etc/atlas/conf/atlas-simple-authz-policy.json`}
    </SyntaxHighlighter>
    <p>{`Please note that if the policy file location specified is not an absolute path, the file will be looked up in following paths:`}</p>
    <ul>
      <li parentName="ul">{`Apache Atlas configuration directory (specified by system property =atlas.conf=)`}</li>
      <li parentName="ul">{`Apache Atlas server's current directory`}</li>
      <li parentName="ul">{`CLASSPATH`}</li>
    </ul>
    <h3 {...{
      "id": "policy-file-format"
    }}>{`Policy file format`}</h3>
    <p>{`Simple authorizer uses =roles= to group permissions, which can then be assigned to users and user-groups. Following examples
would help to understand the details of the policy file format:`}</p>
    <h3 {...{
      "id": "roles"
    }}>{`Roles`}</h3>
    <p>{`Following policy file defines 3 roles:`}</p>
    <ul>
      <li parentName="ul">{`ROLE_ADMIN: has all permissions`}</li>
      <li parentName="ul">{`PROD_READ_ONLY: has access to read entities having qualifiedName ending with "@prod"`}</li>
      <li parentName="ul">{`TEST_ALL_ACCESS: has all access to entities having qualifiedName ending with "@test"`}</li>
    </ul>
    <p>{`Simple authorizer supports Java reg-ex to specify values for privilege/entity-type/entity-id/classification/typeName/typeCategory.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
  "roles": {
    "ROLE_ADMIN": {
      "adminPermissions": [
        {
          "privileges": [ ".*" ]
        }
      ],
  "entityPermissions": [
    {
      "privileges":      [ ".*" ],
      "entityTypes":     [ ".*" ],
      "entityIds":       [ ".*" ],
      "classifications": [ ".*" ]
    }
  ],

  "typePermissions": [
    {
      "privileges":     [ ".*" ],
      "typeCategories": [ ".*" ],
      "typeNames":      [ ".*" ]
    }
  ]
},

"PROD_READ_ONLY" : {
  "entityPermissions": [
    {
      "privileges":      [ "entity-read", "entity-read-classification" ],
      "entityTypes":     [ ".*" ],
      "entityIds":       [ ".*@prod" ],
      "classifications": [ ".*" ]
    }
}

"TEST_ALL_ACCESS" : {
  "entityPermissions": [
    {
      "privileges":      [ ".*" ],
      "entityTypes":     [ ".*" ],
      "entityIds":       [ ".*@test" ],
      "classifications": [ ".*" ]
    }
}
  },
  "userRoles": {
   ...
  },
  "groupRoles": {
   ...
  }
}`}
    </SyntaxHighlighter>
    <h3 {...{
      "id": "assign-roles-to-users-and-user-groups"
    }}>{`Assign Roles to Users and User Groups`}</h3>
    <p>{`Roles defined above can be assigned (granted) to users as shown below:`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
  "roles": {
   ...
  },
  "userRoles": {
    "admin":   [ "ROLE_ADMIN" ],
    "steward": [ "DATA_STEWARD" ],
    "user1":   [ "PROD_READ_ONLY" ],
    "user2":   [ "TEST_ALL_ACCESS" ],
    "user3":   [ "PROD_READ_ONLY", "TEST_ALL_ACCESS" ],
  },
  "groupRoles": {
   ...
  }
}`}
    </SyntaxHighlighter>
    <p>{`Roles can be assigned (granted) to user-groups as shown below. A user can belong to multiple groups; roles assigned to
all groups the user belongs to will be used to authorize the access.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
  "roles": {
   ...
  },
  "userRoles": {
   ...
  },
  "groupRoles": {
    "admins":        [ "ROLE_ADMIN" ],
    "dataStewards":  [ "DATA_STEWARD" ],
    "testUsers":     [ "TEST_ALL_ACCESS" ],
    "prodReadUsers": [ "PROD_READ_ONLY" ]
  }
}`}
    </SyntaxHighlighter>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;